import {Product365} from './Product365'

export class Product {
    product365
    addOns
    places
    formAnswers
    

    constructor() {   
        this.addOns = []
        this.formAnswers = []
    }

    get() {
        return {
            product365: this.product365,
            addOns: this.addOns,
            places: this.places,
            formAnswers: this.formAnswers
        }
    }

    /**
     * 
     * @param {Product365} product365 
     */
    updateProduct(product365) {
        this.product365 = product365
    }

    updatePlaces(placesAmount) {
        this.places = placesAmount
    }

    addAddOn(addOnId) {
        if(this.addOns.includes(addOnId)) return
        this.addOns.push(addOnId)
    }

    addFormAnswer(answer) {
        this.formAnswers.push(answer)
    }



}